import capterra from '@images/capterra.svg';
import capterraWhite from '@images/capterraWhite.svg';
import crozdesk from '@images/crozdesk.svg';
import crozdeskWhite from '@images/crozdeskWhite.svg';
import g2ReviewStars from '@images/g2-review-stars.svg';
import g2ReviewStarsWhite from '@images/g2-review-starsWhite.svg';
import softwareAdvice from '@images/softwareAdvice.svg';
import softwareAdviceWhite from '@images/softwareAdviceWhite.svg';
import trustpilot from '@images/trustpilot.svg';
import trustpilotWhite from '@images/trustpilotWhite.svg';
import trustRadius from '@images/trustRadius.svg';

const reviews = [
    {
        alt: 'Software Advice',
        id: 1,
        link: 'https://www.softwareadvice.com/hr/traqq-profile/',
        src: softwareAdvice
    },
    {
        alt: 'crozdesk',
        id: 2,
        link: 'https://crozdesk.com/software/traqq',
        src: crozdesk
    },
    {
        alt: 'Trustpilot',
        id: 3,
        link: 'https://www.trustpilot.com/review/traqq.com',
        src: trustpilot
    },
    {
        alt: 'Capterra',
        id: 4,
        link: 'https://www.capterra.com/p/230726/Traqq/',
        src: capterra
    },
    {
        alt: 'TrustRadius',
        id: 5,
        link: 'https://www.trustradius.com/products/traqq/reviews',
        src: trustRadius
    },
    {
        alt: 'G2 reviews rating',
        id: 6,
        link: 'https://www.g2.com/products/traqq/reviews',
        src: g2ReviewStars
    }
];

const reviewsWhiteIcons = [
    { ...reviews[0], src: softwareAdviceWhite },
    { ...reviews[1], src: crozdeskWhite },
    { ...reviews[2], src: trustpilotWhite },
    {...reviews[3], src: capterraWhite},
    {...reviews[4], className: 'w-[120px] 480:!w-[138px]'},
    {...reviews[5], src: g2ReviewStarsWhite}
];

export default reviews;

export { reviewsWhiteIcons } ;
